import { FaPlug, FaSpinner } from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";

const AccountCard = ({ account, isActive, isConnected, isConnecting, onSelect, onToggleConnect }) => {
  return (
    <div
      onClick={() => onSelect(account.id)}
      className={`flex items-center gap-3 px-3 py-2.5 cursor-pointer transition-colors border-b border-gray-100
        ${isActive ? "bg-orange-50 border-l-[3px] border-l-orange-500" : "hover:bg-gray-100 border-l-[3px] border-l-transparent"}`}
    >
      <div className="relative">
        <div className={`w-9 h-9 rounded-full flex items-center justify-center ${isConnected ? "bg-orange-100 text-orange-600" : "bg-gray-200 text-gray-500"}`}>
          <MdOutlineMail className="text-lg" />
        </div>
        <span className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white ${isConnected ? "bg-green-500" : "bg-gray-400"}`} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-gray-800 truncate">{account.nombre}</p>
        <p className="text-[10px] text-gray-500 truncate">{account.imapUser}</p>
      </div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onToggleConnect(account.id);
        }}
        disabled={isConnecting}
        className={`p-1.5 rounded-md transition-colors ${
          isConnecting
            ? "text-gray-400"
            : isConnected
              ? "text-green-600 hover:bg-green-50"
              : "text-gray-400 hover:bg-gray-200"
        }`}
        title={isConnected ? "Desconectar" : "Conectar"}
      >
        {isConnecting ? <FaSpinner className="animate-spin text-xs" /> : <FaPlug className="text-xs" />}
      </button>
    </div>
  );
};

export default AccountCard;
